// src/theme/theme.ts
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#10551fff', // Blue color
    },
    secondary: {
      main: '#04320aff', // Pink color
    },
  },
  typography: {
    fontFamily: '"Roboto", sans-serif',
  },
});

export default theme;

// export const brandColors ={
//   primary: '#03360aff',
//   secondary: '#11671cff',
//   tertiary: '#bcffd1ff',
//   black: '#000000ff',
//   white: '#ffffffff'
// }